<template>
  <div v-if="page_loading">
      <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title style="height: 60px;">
        <h4>COD WALLET</h4> <v-icon>mdi-chevron-right</v-icon>  <span class="font-weight-regular body-1"> {{ use_language.cod_info }} </span>
        <v-spacer/>
        <vue-excel-xlsx
            :data="datalist"
            :columns="excel_wallet_detail_header"
            :file-name="use_language.report_cod"
            
            >
            <v-btn color="success" outlined >Export to Excel</v-btn>
        </vue-excel-xlsx>
      </v-card-title>
    </v-card>
    <v-card class="elevation-0 v-card-bottom-30">
      <v-card-title>
       <font class="hidden-xs-only" >{{ use_language.data }} {{ codWalletID }} ({{ use_language.receipt_issuing_time }} {{ formatDatetime(codWalletDate) }})</font>
       <font class="hidden-sm-and-up" >{{ use_language.data }} {{ codWalletID }}<br>({{ use_language.receipt_issuing_time }} {{ formatDatetime(codWalletDate) }})</font>
      </v-card-title>
      <v-card-text>
        <!-- PC -->
        <v-data-table
          :headers="headers"
          :items="datalist"
          hide-default-footer :items-per-page="10000"
          item-key="orderID"
          class="elevation-0 packhai-border-table hidden-xs-only"
          >
          <template v-slot:item.orderID="{ item }">
            <a href="#" class="text-info" @click="detail_page(item)"> {{  item.orderID  }}</a>
          </template>


          <template v-slot:item.sendToExpressDatetime="{ item }">
            {{ formatDatetime(item.sendToExpressDatetime) }}
          </template>
          <template v-slot:item.createdDatetime="{ item }">
            {{ formatDatetime(item.createdDatetime) }}
          </template>
          <template v-slot:item.parcelSuccessDateTime="{ item }">
            {{ formatDatetime(item.parcelSuccessDateTime) }}
          </template>
          <template v-slot:item.realTransferDatetime="{ item }">
            {{ formatDatetime(item.realTransferDatetime) }}
          </template>
          <template v-slot:item.codAmount="{ item }">
            {{ format_price(item.codAmount) }}
          </template>
        
          <template v-slot:item.expressCompanyLogo="{ item }">
            <div align="center">
              <v-img style="margin:5px;"
                :src="item.expressCompanyLogo"
              
                max-width="50"
                max-height="50"
              ></v-img>
            </div>
          </template>
          <template v-slot:item.channelLogo="{ item }">
            <div align="center">
              <v-img style="margin:5px;"
                :src="item.channelLogo"
              
                max-width="20"
                max-height="20"
              ></v-img>
            </div>
          </template>
        </v-data-table>
        <!-- Mobile -->
        <div >
          <v-simple-table class="hidden-sm-and-up packhai-border-table" >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="min-width: 100px;">
                    {{ use_language.menu_orders }}
                  </th>
                  <th class="text-left" style="min-width: 170px;">
                    {{ use_language.send_to_express }}
                  </th>
                  <th class="text-center" style="min-width: 100px;">
                    {{ use_language.transport }}
                  </th>
                  <th class="text-left" style="min-width: 100px;">
                    {{ use_language.track_number }}
                  </th>
                  <th class="text-left" style="min-width: 250px;">
                    {{ use_language.receiver_name }}
                  </th>
                  <th class="text-right" style="min-width: 120px;">
                    {{ use_language.cod_amount }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in datalist" :key="index" >
                  <td class="text-left">
                    <a href="#" class="text-info" @click="detail_page(item)"> {{  item.orderID  }}</a>
                   
                  </td>
                  <td class="text-left">{{ formatDatetime(item.sendToExpressDatetime) }}</td>
                  <td class="text-center">
                    <v-img style="margin:5px;"
                      :src="item.expressCompanyLogo"
                     
                      max-width="50"
                      max-height="50"
                    ></v-img>
                  </td>
                  <td class="text-left">{{ item.trackingNo }}</td>
                  <td class="text-left">{{ item.receiverName }}</td>
                  <td class="text-right">{{ format_price(item.codAmount) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div align="right" class="my-2">
          {{ use_language.sum_total }}  {{ format_price(this.sun_CODAmount) }} {{ use_language.baht }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Loading from '@/website/components/Loading'
  import axios from 'axios'
  import { shopService_dotnet } from '@/website/global'
  import { format_number, format_order_id, format_price, FormatInvoice, FormatCODWallet, set_format_date_time,formatDatetime, get_languages } from '@/website/global_function'
   
  export default {
    components: {
        Loading
    },

    data: () => ({
      use_language: {},
      header_token:{'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')},
      page_loading: true,
      loading: false,
        datalist: [],
        to_excel_data: [],
        sun_CODAmount: "0",
        codWalletID: null,
        codWalletDate: null,

    }),
    computed: {
      headers() {
        return [
          { text: this.use_language.menu_orders, align: 'center', value: 'orderID', sortable: false },
          { text: this.use_language.create_date, align: 'center', value: 'createdDatetime', sortable: false },
          { text: this.use_language.send_to_express, align: 'center', value: 'sendToExpressDatetime', sortable: false },
          { text: this.use_language.order_tab_count_success, align: 'center', value: 'parcelSuccessDateTime', sortable: false  },
          { text: this.use_language.date_of_deposit, align: 'center', value: 'realTransferDatetime', sortable: false },
          { text: this.use_language.channel, align: 'center', value: 'channelLogo', sortable: false },
          { text: this.use_language.transport, align: 'center', value: 'expressCompanyLogo', sortable: false },
          { text: this.use_language.track_number, align: 'center', value: 'trackingNo', sortable: false  },
          { text: this.use_language.receiver_name, align: 'left', value: 'receiverName', sortable: false },
          { text: this.use_language.cod_amount, align: 'right', value: 'codAmount', sortable: false },
        ]
      },
      excel_wallet_detail_header() {
        return [
          { label: this.use_language.order_number, field: "orderID", width: 20},
          { label: this.use_language.create_date, field: "createdDatetime", width: 30   },
          { label: this.use_language.send_to_express, field: "sendToExpressDatetime", width: 30   },
          { label: this.use_language.order_tab_count_success, field: "parcelSuccessDateTime", width: 30   },
          { label: this.use_language.date_of_deposit, field: "realTransferDatetime", width: 30   },
          { label: this.use_language.in_account, field: "fullBankName", width: 20 },
          { label: this.use_language.channel, field: "channelName", width: 25 },
          { label: this.use_language.transport, field: "expressCompanyName", width: 25 },
          { label: this.use_language.track_number, field: "trackingNo", width: 25 },
          { label: this.use_language.receiver_name, field: "receiverName", width: 30 },
          { label: this.use_language.cod_amount, field: "codAmount", width: 15 }
        ]
      },
    },
    async created() {
      this.use_language = await this.get_languages(localStorage.getItem("set_language"));
      try {
        this.CODReportID = this.$route.query.id
        if (typeof(this.CODReportID) ==='undefined') {
          window.close()
        } else {
          await this.get_order_cod()
        }
      } catch (e) {
        window.close()
      }

      this.page_loading = false

    },
    methods: {
      get_languages,
      format_number, format_order_id, format_price, FormatInvoice, FormatCODWallet, set_format_date_time,formatDatetime,
      async get_order_cod () {

        this.loading = true

        let res1 = await axios.post(shopService_dotnet+'CODWallet/get-cod-wallet-detail',{'reportID' : this.CODReportID, 'shopID': localStorage.getItem("shop_id")},{ headers: this.header_token})
        this.datalist = res1.data.data_list
        this.sun_CODAmount = res1.data.sumCODAmount
        this.codWalletID = res1.data.codWalletID
        this.codWalletDate = res1.data.codWalletDate

        this.loading = false

      },

      detail_page (item) {
        window.open('order-detail?id='+item.orderMasterID+'&token='+item.token, '_blank');
      },
    }
  }
</script>
<style>
  .packhai-border-table{
    /* border:1px solid #e9edf4; */
    border-collapse: collapse;
    border-spacing: 0px;
    border-right: 1px solid #e9edf4;
    border-bottom: 1px solid #e9edf4;
    border-top: 1px solid #e9edf4;
  }
  .packhai-border-table thead{
    color:white;
  }
  .packhai-border-table thead tr th{
    color: black !important;
    font-weight: bold;
    font-size: 14px;
  }
  .packhai-border-table tr {
    /* border-collapse: collapse; */
    /* border: 1px solid #e9edf4; */
  }
  .packhai-border-table th {
    /* border-collapse: collapse; */
      border-left: 1px solid #e9edf4;
  }
  .packhai-border-table tr td{
    border-left: 1px solid #e9edf4;
  }


</style>
